import { useEffect, useState } from 'react';
import axios from 'axios';

export default function useImportToolUsage({ startDate, endDate } = {}) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      setError(null);

      try {
        const sessionID = localStorage.getItem('sessionId');
        const authToken = localStorage.getItem('authToken');
        
        if (!authToken) {
          throw new Error('No authentication token found');
        }

        const params = {};
        if (startDate) params.start = startDate;
        if (endDate) params.end = endDate;

        const { data: result } = await axios.get(
          `${process.env.REACT_APP_BACKEND_URL}/api/auth/analytics/import-tool-usage`,
          {
            headers: {
              Authorization: `Bearer ${authToken}`,
              'x-session-id': sessionID,
            },
            params,
          }
        );

        setData(result);
      } catch (err) {
        console.error('Failed to load import tool usage data:', err);
        setError(err.response?.data?.message || err.message || 'Failed to load data');
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [startDate, endDate]);

  return { data, loading, error };
} 